import { render, staticRenderFns } from "./ReelModalBanner.vue?vue&type=template&id=be4b5daa&scoped=true"
import script from "./ReelModalBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReelModalBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReelModalBanner.vue?vue&type=style&index=0&id=be4b5daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b5daa",
  null
  
)

export default component.exports